import React, {useEffect, useState} from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import parse, { attributesToProps } from "html-react-parser";
import { isMobile } from "@/utils/common";

// 下面 一块的区域
export default function DroppableComDown({ item1, direction,optionForm,titleTbleData,col,maxItemHeight }) {
  let _item = [];
  if (direction) {
    _item = item1.options1 ? item1.options1 : [];
  } else {
    _item = item1.selctData ? item1.selctData : [];
  }
  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? "#eee" : "#fff",
    flex: 1,
    // minWidth:100,
    minHeight: "145px",
    border: "1px solid #ccc",
    // borderRight: "none",
    borderTop: "none",
    display: "flex",
    flexWrap: "wrap",
    alignItems:'flex-start',
    overflowY:"auto",
    alignContent:'flex-start',
  });
  const [tbleHeight,setTbleHeight]=useState(null)
  useEffect(() => {
    setTimeout(() => {
      _item.map((item, index) => {
        console.log(1111, document.getElementById(item.id+"img"));
      });
    }, 500);

  }, [ ])
  useEffect(()=>{
    let ele=document.getElementById(`titleTbleReference-${col}`)
    const observer = new ResizeObserver(() => {
      // 更新元素高度
      setTbleHeight(ele.offsetHeight+'px');
    });

    // 开始观察元素
    observer.observe(ele);

    // 清理函数：在组件卸载时停止观察
    return () => {
      observer.disconnect();
    };


  },[])


  const options = {
    replace: (domNode) => {
      if (domNode.attribs && domNode.name === "img") {
        const props = attributesToProps(domNode.attribs);
        console.log('propsprops',props);
        return (
          <img
            {...props}
            style={{
              // width: isMobile ? "100%" : "",
              // height: isMobile ? "100%" : "",
              // maxHeight: 120,
              // maxWidth: 120,
            }}
          />
        );
      }
    },
  };
  const titleTble = (childs) => (
      <div
          key={titleTbleData?.id}
          style={{
            border: "1px solid #ccc",
            background: "rgb(204, 204, 204)",
            borderRight: "1px solid #fff",
            textAlign: "center",
            height:tbleHeight||'60px'
          }}
      >
        <div dangerouslySetInnerHTML={{__html: imgSetStyle(titleTbleData?.description,'60px')}}></div>
        {/* 下面块区域 */}
      </div>
  );
  const imgSetStyle=(htmlText,maxHeight)=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, 'text/html');
    // 查找 <img> 标签并修改属性
    const img = doc.querySelector('img');
    if (img) {
      img.setAttribute('width','none')
      img.setAttribute('height','none')
      img.setAttribute('style', maxHeight?`max-width: 100%;object-fit: contain;max-height:${maxHeight};height:100%`:
          `max-width: 100%;object-fit: contain;max-height:100%`); // 修改样式
    }
    return doc.body.innerHTML
  }
  return (
  < >
    {optionForm === 5 && titleTble(titleTbleData)}
    <Droppable droppableId={item1.id} direction={"vertical"}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          style={getListStyle(snapshot.isDraggingOver)}
        >
          {_item.map((item, index) => (
            <Draggable
              key={item.id}
              draggableId={item.codeValue + ""}
              index={index}
            >
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  style= {snapshot.isDragging ?
                      {...provided.draggableProps.style}:
                      {
                        ...provided.draggableProps.style,
                    }}
                >
                  <div style={{ display: "flex", justifyContent: "center" ,margin:5}}>
                    <div
                      style={{
                        overflow: "hidden",
                        background: "#f5f5f5",
                        // textAlign: "center",
                        display:"flex",
                        margin: "0px 10px 0px 10px",
                        border: "1px solid",
                        flex:'1',
                        aspectRatio:"1/1",
                        width: maxItemHeight,
                        // margin: isMobile ? 0 : "5px",
                      }}
                    >

                      <div  dangerouslySetInnerHTML={{__html:imgSetStyle(item.description)}}></div>
                     {/* {parse(
                        item.description
                          .replace(/<p><\/p>/g, "<br />")
                          .replace(/\n\n/g, "<br />")
                          .replace(/\s{2}/g, "&nbsp;&nbsp;")
                          .replace(/height="[0-9]+px"/g, '')
                          .replace(/height:.?[0-9]+px/g, "")
                          .replace(/width="[0-9]+px"/g, 'width="100%"')
                          .replace(/width:.?[0-9]+px/g, "width:100%"),
                        options
                      )} */}
                    </div>
                  </div>
                </div>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
    {optionForm === 6 && titleTble(titleTbleData)}
  </>
  );
}
